"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    connectionURL: "wss://0mvjn4qu0i.execute-api.us-east-1.amazonaws.com/live?auth=something",
    timeoutInMilliseconds: 10000,
};
//# sourceMappingURL=Config.js.map